import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  createComponent,
  EnvironmentInjector,
  Inject,
  OnDestroy,
  OnInit,
  Type
} from '@angular/core';
import {OnDestroy$} from '@pdtec/ngx-observable-lifecycle';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from './config/hotel-tours-list-page.config';
import {MODE} from './models';
import {environment} from "../environments/environment";
import {Router} from "@angular/router";
import {APP_CONFIG, AppConfig} from "./config/app.config";
import { WindowRefService } from './services/window-ref.service';
import { FindToursFiltersShellComponent } from './pages/find-tours/find-tours-filters-shell.component';

@Component({
  selector: 'app-root',
  templateUrl: environment.mobile ? './app.component.mobile.html' : './app.component.html',
  styleUrls: environment.mobile ? ['./app.component.mobile.scss'] : ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends OnDestroy$ implements OnInit, AfterViewInit, OnDestroy {
  private externalComponentRefs: ComponentRef<unknown>[] = [];

  constructor(
    private router: Router,
    private windowService: WindowRefService,
    private appRef: ApplicationRef,
    private environmentInjector: EnvironmentInjector,
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
  ) {
    super();
  }

  public mode = this.hotelToursPageConfig.mode;
  public readonly MODE = MODE;

  ngOnInit() {

  }

  ngAfterViewInit(): void {
    this.mountExternalComponent('app-find-tours-filters-shell', FindToursFiltersShellComponent);
  }

  ngOnDestroy(): void {
    this.externalComponentRefs.forEach((componentRef) => componentRef.destroy());
    this.externalComponentRefs = [];
    super.ngOnDestroy();
  }

  public get isTourList() {
    return this.hotelToursPageConfig.mode === MODE.MODE_TOUR_LIST;
  }

  public get isPriceCalendar() {
    return this.hotelToursPageConfig.mode === MODE.MODE_PRICE_CALENDAR;
  }

  private mountExternalComponent<T>(selector: string, component: Type<T>): void {
    const document = this.windowService.nativeWindow.document as Document;
    const hostElements = Array.from(
      document.querySelectorAll<HTMLElement>(selector)
    );

    hostElements
      .filter((hostElement) => !hostElement.closest('app-root'))
      .forEach((hostElement) => {
        const componentRef = createComponent(component, {
          hostElement: hostElement as HTMLElement,
          environmentInjector: this.environmentInjector,
        });

        this.appRef.attachView(componentRef.hostView);
        this.externalComponentRefs.push(componentRef);
      });
  }
}
